import { Theme, withStyles, WithStyles } from '@material-ui/core';
import { createStyles } from '@material-ui/core/styles';
import React from 'react';
import { IFilter, IFilters } from '../../models/states';
import FilterItem from '../FilterItem/FilterItem';
const styles = (theme: Theme) =>
  createStyles({
    root: {}
  });

class FilterBar extends React.Component<IFilterBarProps> {
  public render() {
    return Object.keys(this.props.filters).map((filterName: string) => {
      return this.props.filters[filterName].map((f: any) => {
        if (f.isSet) {
          return (
            <FilterItem
              key={f.label}
              label={f.label}
              onClose={() => this.props.toggleFilter(filterName, f)}
            />
          );
        }
      });
    });
  }
}
interface IFilterBarOwnProps extends WithStyles<typeof styles> {
  toggleFilter: (filterName: string, filter: IFilter) => any;
  filters: IFilters;
}

type IFilterBarProps = IFilterBarOwnProps;

export default withStyles(styles)(FilterBar);
